export default __webpack_public_path__ + "static/media/download.54d538f3.jpg";